export default __webpack_public_path__ + "static/media/iit.c9970876.png";